import { useEffect } from 'react'
import { showToast } from 'shared/ui'
import { WebsocketEvent } from 'entities/WebSocket'
import { useEntitiesContext } from 'entities/EntitiesExport'
import { type HubspotWorkflowsListStore } from 'pages/hubspotWorkflows/ui/hubspotWorkflowsList/store/HubspotWorkflowsListStore'

export const useEventOrganizationHubspotWorkflowSyncFinished = (
  store: HubspotWorkflowsListStore
) => {
  const { websocket } = useEntitiesContext()
  const handler = async () => {
    showToast({
      title: 'Update complete',
      desc: 'Your workflow stats have been updated with the latest data.',
      type: 'success',
    })

    await store.loadData()
    store.setStartSync(false)
  }

  useEffect(() => websocket.on(WebsocketEvent.OrganizationHubspotWorkflowSyncFinished, handler), [])
}
